<template>
  <div class="products-slider">
    <h1 style="text-align: center;" class="pt-5">{{ title }}</h1>
    <v-slide-group show-arrows>
      <v-slide-item v-for="(product, i) in boughtProducts.filter(p => p.onlineStock > 0)" :key="i" v-slot:default="{ active, toggle }"
        class="mx-2 hover-zoom py-3" style="cursor: pointer">
        <B2CItemCard :style="cardWidth" @clickButton="addBtnAction(product)" @clickCard="goToProductDetails(product)" :id="product.idBase64"
          :title="product.title" type="P" :imageUrl="product.imgUrl" :subtitle="product.brandName"
          :price="productPrice(product)" :stockAmount="product.onlineStock"
          :campaignValue="product.bestCampaign && product.bestCampaign.benefitRule === 2 ? 0 : discountPrice(product)"
          :campaignText="campaignText(product)" class="ma-3">
        </B2CItemCard>
       
      </v-slide-item>
    </v-slide-group>
  </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import B2CItemCard from "@fixit/v-b2c-item/src/B2CItemCard.vue";


export default {
  mixins: [webshopMixins],
  props: {
    boughtProducts: Array,
    title: String
  },
  components: {
    B2CItemCard
  },
  data() {
    return {
      windowSize: { x: window.innerWidth, y: window.innerHeight }
    };
  },
  computed: {
    cardWidth() {
      let width = ''
      switch(true) {
        case this.$vuetify.breakpoint.lg:
        case this.$vuetify.breakpoint.xl:
          width = '320px'
          break;
        case this.$vuetify.breakpoint.md:
        case this.$vuetify.breakpoint.sm:
          width = '250px'
          break;
        default:
          width = '164px'
      }
      return `width: ${width}`
    }
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    openSalonSelectDialog(product) {
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product,
      });
      this.$store.dispatch("webshop/set", {
        key: "salonPickOptions",
        value: { dialog: true },
      });
    },
    addBtnAction(product) {
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product,
      });
      this.addProductToSalonCart(this.salons[0]);
    },
    productDiscount(product) {
      if (product.discounts.length) {
        let discount = product.discounts[0]
        return Math.round(
          ((discount.OriginalPrice - discount.DiscountPrice) /
            discount.OriginalPrice) *
          100
        );
      }
      return Math.round(
        ((product.productDetails.price - product.salePrice) /
          product.productDetails.price) *
        100
      );
    },
    productPrice(product) {
      if (product.discounts.length) {
        return product.discounts[0].OriginalPrice;
      } else {
        return product.salePrice === 0 ? product.productDetails.price : product.salePrice;
      }
    },
    discountPrice(product) {
      if (product.discounts.length) {
        return Math.min(product.discounts.map((x) => x.DiscountPrice));
      } else return undefined;
    },
    campaignText(product) {
      if (product.bestCampaign) {
        if (product.bestCampaign.PromotionType === 1) {
          //BUNDLE
          return "";
        } else if (product.bestCampaign.PromotionType === 3) {
          return "Nyhet";
        } else {
          switch (product.bestCampaign.BenefitRule) {
            case 0:
              return product.PromotionType !== 1
                ? product.bestCampaign.AdditionalValue + "%"
                : "";
            case 1:
              return (
                product.bestCampaign.BenefitQty +
                " for " +
                product.bestCampaign.BenefitValue1
              );
            case 2:
              return (
                product.bestCampaign.BenefitQty +
                " for " +
                product.bestCampaign.BenefitValue1
              );
            default:
              return "";
          }
        }
      } else {
        return "";
      }
    },
  },
  created() {
  }
};
</script>
<style lang="scss" scoped>
.VueCarousel-slide {
  padding: 10px;
}

.VueCarousel {
  max-width: 100%;
}

.action__buttons::v-deep {
  .v-btn {
    height: 42px !important;
  }
}

.product__description div {
  white-space: pre-wrap;
}

.v-skeleton-loader__heading {
  margin: 0 auto;
}

.product-discount-tag {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #ffffff;
  z-index: 1;
}
</style>
<style lang="scss">
.products-slider {
  .v-slide-group {
    &__wrapper {
      padding: 25px 0;
    }

    &__content {
      justify-content: center !important;
    }
  }
}
</style>
